import { createFileRoute } from "@tanstack/react-router";
import { GotwBoard } from "@/features/office";

export const Route = createFileRoute("/_office/unlisted/office/beltholder")({
  head: () => ({
    meta: [
      { title: "Game of the Week — live leaderboard | Softmax" },
      {
        name: "description",
        content:
          "The office wall board: the current Game of the Week, just-played episodes, and every coworld ranked by unique players.",
      },
    ],
  }),
  component: GotwBoard,
});
